import admin from '@/utils/http'

export default {
  state: {
    roles: [
      {
        name: '超级管理员',
        id: 1,
      },
      {
        name: '普通管理员',
        id: 2,
      },
    ],
    company: {},
    contact: {},
    customers: [],
  },
  actions: {
    // 用户
    updateSelf(user) {
      return admin.put('/user/self', user)
    },
    resetPassword(data) {
      return admin.put('/user/resetpassword', data)
    },
    adminResetPassword(data) {
      return admin.put('/user/adminresetpassword', data)
    },
    fetchUser(data) {
      return admin.post('/user/list', data)
    },
    create(user) {
      return admin.post('/user/create', user)
    },
    detail(uid) {
      return admin.get('/user/detail/' + uid)
    },
    update(user) {
      return admin.put('/user/update/' + user.uid, user)
    },
    remove(uid) {
      return admin.delete('/user/' + uid)
    },
    setDefChannel(uid) {
      return admin.put('/user/defchannel', {uid})
    },

    // 客户
    async fetchCustomer(force) {
      if (this.customers && this.customers.length && !force) {
        return this.customers
      }
      return admin.post("/customer/list", {
        offset: 0,
        limit: 100000000,
      }).then(r => {
        this.customers = r.list
        return this.customers
      })
    },
    detailCustomer(id) {
      return this.fetchCustomer().then(list => list.find(i => i.uid == id))
    },
    createCustomer(data) {
      return admin.post("/customer/create", data)
    },
    updateCustomer(data) {
      return admin.put("/customer/update", data)
    },
    customersAndMe() {
      return [
        {
          ...this.$root.auth.user,
          ...this.company,
        },
        ...this.customers,
      ]
    },

    // 管理员
    fetchAdmin(query) {
      return admin.get('/admin/list', { query })
    },
    createAdmin(data) {
      return admin.post('/admin/create', data)
    },
    removeAdmin(data) {
      return admin.post('/admin/delete', data)
    },

    // company
    async getCompany(force) {
      if (this.company.uid && !force) {
        return this.company
      }
      const company = await admin.get('/user/company')
      this.company = company
      return company
    },
    updateCompany(data) {
      return admin.put('/user/company', data)
    },
    async getContact() {
      const contact = await admin.get('/user/contact')
      this.contact = contact
      return contact
    },
    updateContact(data) {
      return admin.put('/user/contact', data)
    },

    // price
    updatePrice(data) {
      return admin.put('/admin/price', data)
    },


  }
}